import React from 'react';
import { Box } from '@mui/material';
import ManifestClienteDashboard from '../../components/cliente/ManifestClientDashboard'

const ViajesClientePage = () => {
  return (
    <Box sx={{ p: 2 }}>
      <ManifestClienteDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de manifiesto cliente:', newOrder);
        }}
      />
    </Box>
  );
};

export default ViajesClientePage;